import { t } from "i18next";
import { capitalize } from "../../../../../../../locales/i18n";

import type { EditorId, FnConfig } from "./types";

export const anyFn = (): FnConfig => [
  "isAny",
  t("conditions.any"),
  true,
  undefined,
];

export const changesFn = (): FnConfig => [
  "changes",
  capitalize(t("general.change.other")),
  true,
  undefined,
];

export const containsFn = (
  editorId: EditorId = "text",
  fieldType?: string,
): FnConfig => [
  "contains",
  fieldType === "linkedrecordfield"
    ? t("conditions.has-any-of")
    : t("conditions.contains"),
  true,
  editorId,
];

export const notContainsFn = (
  editorId: EditorId = "text",
  fieldType?: string,
): FnConfig => [
  "notContains",
  fieldType === "linkedrecordfield"
    ? t("conditions.has-none-of")
    : t("conditions.not-contains"),
  true,
  editorId,
];

export const isFn = (
  multiple: boolean = true,
  editorId: EditorId = "text",
): FnConfig => ["isEquals", t("conditions.is"), multiple, editorId];

export const isEqualsFn = (
  multiple: boolean = true,
  editorId: EditorId = "text",
): FnConfig => ["isEquals", t("conditions.is-equals"), multiple, editorId];

export const isNotFn = (
  multiple: boolean = true,
  editorId: EditorId = "text",
): FnConfig => ["isNotEquals", t("conditions.is-not"), multiple, editorId];

export const isNotEqualsFn = (
  multiple: boolean = true,
  editorId: EditorId = "text",
): FnConfig => [
  "isNotEquals",
  t("conditions.is-not-equals"),
  multiple,
  editorId,
];

export const isEmptyFn = (): FnConfig => [
  "isEmpty",
  t("conditions.is-empty"),
  true,
  undefined,
];
export const isNotEmptyFn = (): FnConfig => [
  "isNotEmpty",
  t("conditions.is-not-empty"),
  true,
  undefined,
];

export const lessThanFn = (editorId: EditorId): FnConfig => [
  "lessThan",
  t("conditions.less-than"),
  false,
  editorId,
];

export const isAfterFn = (editorId: EditorId): FnConfig => [
  "greaterThan",
  t("conditions.is-after"),
  false,
  editorId,
];

export const greaterThanFn = (editorId: EditorId): FnConfig => [
  "greaterThan",
  t("conditions.greater-than"),
  false,
  editorId,
];

export const isOnOrBeforeFn = (editorId: EditorId): FnConfig => [
  "lessThanOrEquals",
  t("conditions.is-on-or-before"),
  false,
  editorId,
];

export const lessThanOrEqualsFn = (editorId: EditorId): FnConfig => [
  "lessThanOrEquals",
  t("conditions.less-than-or-equals"),
  false,
  editorId,
];

export const isOnOrAfterFn = (editorId: EditorId): FnConfig => [
  "greaterThanOrEquals",
  t("conditions.is-on-or-after"),
  false,
  editorId,
];

export const greaterThanOrEqualsFn = (editorId: EditorId): FnConfig => [
  "greaterThanOrEquals",
  t("conditions.greater-than-or-equals"),
  false,
  editorId,
];

export const hasAnyOfFn = (editorId: EditorId): FnConfig => [
  "hasAnyOf",
  t("conditions.has-any-of"),
  true,
  editorId,
];

export const hasAllOfFn = (editorId: EditorId): FnConfig => [
  "hasAllOf",
  t("conditions.has-all-of"),
  true,
  editorId,
];

export const hasNoneOfFn = (editorId: EditorId): FnConfig => [
  "hasNoneOf",
  t("conditions.has-none-of"),
  true,
  editorId,
];

export const allItemsResolvedFn = (): FnConfig => [
  "allItemsResolved",
  t("conditions.all-items-resolved"),
  false,
  undefined,
];

export const notAllItemsResolvedFn = (): FnConfig => [
  "notAllItemsResolved",
  t("conditions.not-all-items-resolved"),
  false,
  undefined,
];

export const percentCompleteGreaterThanFn = (editorId: EditorId): FnConfig => [
  "percentCompleteGreaterThan",
  t("conditions.percent-complete-greater-than"),
  false,
  editorId,
];

export const percentCompleteLessThanFn = (editorId: EditorId): FnConfig => [
  "percentCompleteLessThan",
  t("conditions.percent-complete-less-than"),
  false,
  editorId,
];

export const isCompleteFn = (): FnConfig => [
  "isComplete",
  t("conditions.is-complete"),
  false,
  undefined,
];

export const isNotCompleteFn = (): FnConfig => [
  "isNotComplete",
  t("conditions.is-not-complete"),
  false,
  undefined,
];
